export const meta = {
  id: 'bidirectional-bfs',
  name: 'Bidirectional BFS',
  category: 'Graph',
  complexity: {
    time: 'O(b^(d/2))',
    space: 'O(b^(d/2))'
  },
  description: 'Bidirectional BFS runs two simultaneous BFS searches from source and target, meeting in the middle to reduce the search space exponentially.'
};
